// extracted by mini-css-extract-plugin
export var blogCategoryList = "index-module--blogCategoryList--bb6f3";
export var blogCategoryListContainer = "index-module--blogCategoryListContainer--cdb34";